import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=b62e6fe8"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=b62e6fe8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports